import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'


const _hoisted_1 = { class: "inline-block relative bottom-0 left-0 text-12px xxl:text-14px mr-2" }
const _hoisted_2 = { class: "inline-block relative w-full z-10" }
const _hoisted_3 = {
  key: 1,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
}
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "w-4",
  alt: "up"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "w-4",
  alt: "down"
}
const _hoisted_6 = { class: "w-full bg-white absolute border border-t-0 border-gray-lp-400 rounded-b-md z-40" }
const _hoisted_7 = {
  key: 0,
  class: "pb-2"
}
const _hoisted_8 = {
  key: 1,
  class: "py-4 mb-2 text-gray-lp-300 text-center items-center"
}
const _hoisted_9 = {
  key: 0,
  class: "w-4 mr-3",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("path", {
  fill: "#B82025",
  d: "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
}, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "w-4 mr-3",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("path", {
  fill: "#e0e0e0",
  d: "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
}, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "px-4 py-2 text-gray-lp-300"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, "Item terpilih", -1)
const _hoisted_15 = { class: "flex pt-2" }
const _hoisted_16 = {
  key: 0,
  class: "items-center w-full flex flex-wrap"
}
const _hoisted_17 = {
  key: 0,
  class: "flex flex-row border border-gray-lp-400 rounded-full px-3 py-1 mr-2 mb-3 whitespace-no-wrap"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
  fill: "#ABACAE"
}, null, -1)
const _hoisted_19 = {
  key: 1,
  class: "flex flex-row border border-gray-lp-400 rounded-full px-3 py-1 mr-2"
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" All ")
const _hoisted_21 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z",
  fill: "#ABACAE"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: 
        `w-full mr-4 p-1 ${
          _ctx.isOpenMenu && !_ctx.isDisabled
            ? 'border-l border-t border-r rounded-t'
            : 'border rounded'
        } border-gray-lp-400 text-black-lp-300`
      
    }, [
      _createVNode("div", _hoisted_2, [
        (_ctx.showSearchInput)
          ? (_openBlock(), _createBlock("input", {
              key: 0,
              onFocus: _cache[1] || (_cache[1] = () => (!_ctx.isDisabled ? _ctx.onOpenSelect() : {})),
              onInput: _cache[2] || (_cache[2] = 
            e => {
              if (!_ctx.isDisabled) {
                _ctx.onOpenSelect();
                _ctx.onTyping(e.target.value);
                _ctx.onSearch(e.target.value);
              } else {
              }
            }
          ),
              placeholder: _ctx.placeholder,
              class: 
            `w-full rounded-md leading-tight px-3 py-2 pr-8 font-normal focus:outline-none`
          
            }, null, 40, ["placeholder"]))
          : _createCommentVNode("", true),
        (_ctx.showSearchInput)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              (_ctx.isOpenMenu)
                ? (_openBlock(), _createBlock("img", _hoisted_4))
                : (_openBlock(), _createBlock("img", _hoisted_5))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.showSearchInput)
          ? (_openBlock(), _createBlock("div", {
              key: 2,
              onClick: _cache[3] || (_cache[3] = () => (!_ctx.isDisabled ? _ctx.onOpenSelect() : {})),
              class: " w-40 rounded-md leading-tight px-3 py-2 pr-8 font-normal focus:outline-none cursor-pointer flex items-center"
            }))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_6, [
      _createVNode("div", {
        class: "overflow-auto border-t pt-2",
        style: {"max-height":"155px"},
        onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
      }, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "18.5rem",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "22.5rem",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "16.5rem",
                class: "my-2"
              }),
              _createVNode(_component_Skeleton, {
                height: "1.3rem",
                width: "20.5rem",
                class: "my-2"
              })
            ]))
          : (
            _ctx.valueSearch ? _ctx.optionsBySearch.length === 0 : _ctx.dataSelect.length === 0
          )
            ? (_openBlock(), _createBlock("div", _hoisted_8, " Apa yang Anda cari tidak ditemukan atau tidak ada. "))
            : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.valueSearch ? _ctx.optionsBySearch : _ctx.dataSelect, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: 
            index === (_ctx.optionsBySearch.length - 1 || _ctx.dataSelect.length - 1) &&
              'pb-2'
          
                }, [
                  _createVNode("div", {
                    class: 
              `cursor-pointer flex flex-row items-center px-4 py-1 hover:bg-gray-lp-700 ${index ===
                _ctx.dataSelect.length - 1 && 'pb-2'} ${
                item.isActive ? 'text-red-lp-100' : 'text-black-lp-200'
              }`
            ,
                    onClick: 
              () => {
                if (item.value === 'all') _ctx.isValueActive(true);
                else _ctx.isValueActive(false);
                _ctx.onChooseSelect(item.name, item.value);
              }
            
                  }, [
                    (item.isActive)
                      ? (_openBlock(), _createBlock("svg", _hoisted_9, [
                          _hoisted_10
                        ]))
                      : (_openBlock(), _createBlock("svg", _hoisted_11, [
                          _hoisted_12
                        ])),
                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                  ], 10, ["onClick"])
                ], 2))
              }), 128))
      ], 32)
    ], 512), [
      [_vShow, _ctx.isOpenMenu && !_ctx.isDisabled]
    ]),
    (_ctx.isAnyValue(_ctx.dataValue))
      ? (_openBlock(), _createBlock("div", _hoisted_13, [
          _hoisted_14,
          _createVNode("div", _hoisted_15, [
            (!_ctx.isAllActive)
              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataValue, (item, index) => {
                    return (_openBlock(), _createBlock("div", { key: index }, [
                      (item.isActive)
                        ? (_openBlock(), _createBlock("div", _hoisted_17, [
                            _createTextVNode(_toDisplayString(item.name) + " ", 1),
                            (_openBlock(), _createBlock("svg", {
                              onClick: () => _ctx.onChooseSelect(item.name, item.value),
                              class: "w-4 ml-2",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }, [
                              _hoisted_18
                            ], 8, ["onClick"]))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.isAllActive)
              ? (_openBlock(), _createBlock("div", _hoisted_19, [
                  _hoisted_20,
                  (_openBlock(), _createBlock("svg", {
                    onClick: _cache[5] || (_cache[5] = 
              () => {
                _ctx.isValueActive(false);
                _ctx.onChooseSelect('All', 'all');
              }
            ),
                    class: "w-4 ml-2",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _hoisted_21
                  ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_directive_click_outside, _ctx.onCloseSelect]
  ])
}